import {Grid, IconButton, Typography} from '@logistics-frontend/blocks'
import {CrossIcon} from '@logistics-frontend/blocks/icons'
import {Drawer, DrawerSection} from '@logistics-frontend/blocks/legacy'
import {useI18n} from '@logistics-frontend/core/i18n'
import React from 'react'

import {WebTipsModalProps as Props} from '../types'
import WebTipsIframe from '../WebTipsIframe'
import {classes} from './WebTipsModalMobile.classes'

function WebTipsModalMobile({onClose, payUrl}: Props): React.ReactElement<Props> {
  const t = useI18n()

  return (
    <Drawer className={classes.root} expanderType="none" onClose={onClose}>
      <DrawerSection fullHeight>
        <Grid className={classes.content} direction="column" wrap="nowrap" container>
          <Grid className={classes.header} justify="center" container item>
            <Typography thickness="bold" variant="body2">
              {t('route_tips_title', 'Чаевые курьеру')}
            </Typography>
            <IconButton className={classes.close} onPress={onClose} variant="ghost">
              <CrossIcon />
            </IconButton>
          </Grid>
          <Grid item xs>
            <WebTipsIframe iframeUrl={payUrl} />
          </Grid>
        </Grid>
      </DrawerSection>
    </Drawer>
  )
}

export default WebTipsModalMobile
